// extracted by mini-css-extract-plugin
export var blue = "_1h-f";
export var brand = "_1h-b";
export var darkGrey = "_1h-e";
export var disabled = "_1h-4";
export var disabledSubtle = "_1h-5";
export var error = "_1h-6";
export var green = "_1h-g";
export var grey = "_1h-d";
export var icon = "_1h-0";
export var inherit = "_1h-a";
export var lightGrey = "_1h-c";
export var orange = "_1h-i";
export var pink = "_1h-k";
export var primary = "_1h-1";
export var purple = "_1h-l";
export var red = "_1h-j";
export var secondary = "_1h-2";
export var success = "_1h-9";
export var tertiary = "_1h-3";
export var warning = "_1h-7";
export var warningSecondary = "_1h-8";
export var white = "_1h-m";
export var yellow = "_1h-h";